import {Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Tag} from "../../interface/tag";
import {TagService} from "../../services/tag.service";
import {MatSelectChange} from "@angular/material/select";
import {filter, finalize, first, take, tap} from "rxjs/operators";
import {Dictionary} from "../../interface/dictionary";
import {from, ReplaySubject} from "rxjs";
import {
  DictService,
  POST_TAG_TYPE,
  POST_TAG_TYPE_DEPARTMENT_TYPE, POST_TAG_TYPE_POST_TYPE,
} from "../../services/dict.service";

@Component({
  selector: 'app-dict-tag',
  templateUrl: './dict-tag.component.html',
  styleUrls: ['./dict-tag.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictTagComponent)}
  ]
})

export class DictTagComponent implements OnInit, ControlValueAccessor, OnDestroy, OnChanges{
  @Input() label: string;
  @Input() tagType?: string = null;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() page = false;
  @Input() noneEntry = false;
  @Output() selectedDict: EventEmitter<Tag> = new EventEmitter<Tag>();
  @Output() selectedMultipleDict: EventEmitter<Tag[]> = new EventEmitter<Tag[]>();
  @Output() availableItems: EventEmitter<Tag[]> = new EventEmitter<Tag[]>();


  externalControl = true;
  disabled = false;
  items: Tag[] = [];
  dictItems: Dictionary[] = [];
  value?: number = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private tagService: TagService,
    private dictService: DictService,
    private fb: FormBuilder,
  ) { }

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit(): void {
    if (this.tagType) {

      this.dictService.get( this.tagType , POST_TAG_TYPE )
        .subscribe((dict: Dictionary) => {
          this.dictItems = [];
          this.dictItems.push(dict);
        });
    } else {
      this.loadDictItems(POST_TAG_TYPE);
    }
    this.tagService.getTagDictSubject()
      .pipe(first())
      .subscribe((items: Tag[]) => {
        this.items = items;
        this.items.sort((a, b) => {
          return (a.name ).localeCompare(b.name );
        });
      });
    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  getItems(type: string): any{
    let $val = [];
    this.items.forEach((tag: Tag) => {
      if (tag.type.key === type) {
        $val.push(tag);
      }
    });
    return $val;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }
    if (  this.multiple && this.page) {
      const tagsIds = this.getItems(this.tagType).map((item: Tag) => item.id);
       value = value.filter((val: number) => tagsIds.includes(val));
    }
    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }

  loadDictItems(dictType: string): void {
    this.dictItems = [];
    this.dictService.getDictSubject()
      .pipe(
        take(1)
      )
      .subscribe((items: Dictionary[]) => {
        from(items)
          .pipe(
            filter((e: Dictionary) => e.type === dictType),
            tap((e: Dictionary) => {
              if (!this.dictItems.some((search: Dictionary) => search.id === e.id)) {
                if (![POST_TAG_TYPE_DEPARTMENT_TYPE, POST_TAG_TYPE_POST_TYPE].includes(e.key) )
                {
                  this.dictItems.push(e);
                }
              }
            }),
            finalize(() => {
              this.dictItems = this.dictItems.sort((a: Dictionary, b: Dictionary) => {
                if (a.order > 0) {
                  return a.order - b.order;
                }

                return a.name.localeCompare(b.name);
              });
            })
          ).subscribe();
      });
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
